import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/wcandillon/tmp/tmp/react-native-redash/packages/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "redash"
    }}>{`Redash`}</h1>
    <p><a parentName="p" {...{
        "href": "https://circleci.com/gh/wcandillon/react-native-redash"
      }}><img alt="CircleCI" src="https://circleci.com/gh/wcandillon/react-native-redash.svg?style=svg" /></a>{`
`}<a parentName="p" {...{
        "href": "https://badge.fury.io/js/react-native-redash"
      }}><img alt="npm version" src="https://badge.fury.io/js/react-native-redash.svg" /></a></p>
    <p>{`Utility library for React Native Gesture Handler and Reanimated. As seen on the `}<a parentName="p" {...{
        "href": "http://youtube.com/user/wcandill"
      }}>{`“Can it be done in React Native?”`}</a>{` YouTube series.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn add react-native-redash
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      